
import Vue from 'vue';

import ViewInfoDialog from './ViewInfoDialog.vue';
import ViewEditDialog from './ViewEditDialog.vue';
import ViewDeleteDialog from './ViewDeleteDialog.vue';

import { objectsToCSV, filterItem } from '@/utils/Util';

export default Vue.extend({
  name: 'ViewsTable',

  components: {
    ViewInfoDialog,
    ViewEditDialog,
    ViewDeleteDialog,
  },

  props: ['views', 'loading'],

  data: (vm: any): any => ({
    tableLoadingText: vm.loadingText,
    search: '',
    numberOfEntities: 0,
    selectedHeaders: [
      { text: vm.$t('attribute.description'), value: 'description', index: 10 },
      { text: vm.$t('attribute.entityType'), value: 'entityType', index: 20 },
      { text: vm.$t('attribute.requestType'), value: 'requestType', index: 30 },
      // {
      //   text: vm.$t('attribute.requestConfig'),
      //   value: 'requestConfig',
      //   index: 40,
      // },
      { text: vm.$t('attribute.updatedAt'), value: 'updatedAt', index: 90 },
      { text: vm.$t('attribute.createdAt'), value: 'createdAt', index: 100 },
    ],
  }),

  created() {
    if (this.views?.length === 0) {
      this.tableLoadingText = this.$t('view.noData')
        ? (this.$t('view.noData') as string)
        : 'No data';
    }

    const columns = this.$root.$store.getters.selectedColumns('view');
    if (columns) {
      this.selectedHeaders = columns;
    }
  },

  watch: {
    selectedHeaders() {
      this.$store.commit('setSelectedColumns', {
        type: 'view',
        columns: this.selectedHeaders,
      });
    },
  },

  methods: {
    filterItem,

    formatDateTime(value: any) {
      if (!value) return '-';
      return new Date(value).toLocaleString();
    },

    formatRequestConfig(value: any) {
      if (value === null || value === undefined || value === '') return '-';

      let text = '';
      if (typeof value === 'string') {
        text = value;
      } else {
        try {
          text = JSON.stringify(value);
        } catch {
          text = String(value);
        }
      }

      return text.length > 120 ? text.slice(0, 120) + '…' : text;
    },

    onExport() {
      let filteredItems = this.views;

      const dt: any = (this.$refs as any).dataTable;
      if (dt?.$children?.[0]?.filteredItems) {
        filteredItems = dt.$children[0].filteredItems;
      }

      const data = (filteredItems || []).map((v: any) =>
        Object({
          uuid: v.uuid,
          description: v.description,
          entityType: v.entityType,
          requestType: v.requestType,
          requestConfig: v.requestConfig,
          createdAt: v.createdAt,
          updatedAt: v.updatedAt,
        })
      );

      const filename = 'bascloud_views.csv';
      const csvContent = objectsToCSV(data);
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      if ((navigator as any).msSaveBlob) {
        (navigator as any).msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    onReload() {
      this.$emit('reload');
    },

    onViewItemUpdate(item: any) {
      this.$emit('update', item);
    },

    onViewItemDelete(item: any) {
      this.$emit('delete', item);
    },

    onPaginationAndFilter(pagination: any) {
      this.numberOfEntities = pagination.itemsLength;
    },

    onTableRowClick(row: any) {
      const btn: any = (this.$refs as any)['viewInfoButton_' + row.uuid];
      btn?.$el?.click();
    },
  },

  computed: {
    headers(): any[] {
      return [
        { text: this.$t('attribute.uuid'), value: 'uuid', index: 0 },
        {
          text: this.$t('attribute.description'),
          value: 'description',
          index: 10,
        },
        {
          text: this.$t('attribute.entityType'),
          value: 'entityType',
          index: 20,
        },
        {
          text: this.$t('attribute.requestType'),
          value: 'requestType',
          index: 30,
        },
        // {
        //   text: this.$t('attribute.requestConfig'),
        //   value: 'requestConfig',
        //   index: 40,
        // },
        { text: this.$t('attribute.updatedAt'), value: 'updatedAt', index: 90 },
        {
          text: this.$t('attribute.createdAt'),
          value: 'createdAt',
          index: 100,
        },
      ];
    },

    computedTableHeader(): any {
      return [
        ...this.selectedHeaders,
        {
          text: this.$t('attribute.actions'),
          value: 'actions',
          sortable: false,
          filterable: false,
          index: 9998,
        },
      ].sort((a: any, b: any) => a.index - b.index);
    },

    loadingText(): any {
      return this.$t('loadingData');
    },

    canUpdate(): boolean {
      const res = this.$root.$store.state.session.permissions.resources;
      return res && 'views' in res ? res['views'].includes('PATCH') : false;
    },

    canDelete(): boolean {
      const res = this.$root.$store.state.session.permissions.resources;
      return res && 'views' in res ? res['views'].includes('DELETE') : false;
    },

    canCreate(): boolean {
      const res = this.$root.$store.state.session.permissions.resources;
      return res && 'views' in res ? res['views'].includes('POST') : false;
    },
  },
});
